import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import TodoTab from './TodoTab'
import BudgetPage from '../budget/BudgetPage'
import YourVendors from '../../../components/aisle/YourVendors'
import { useFeatureFlags } from '../../../lib/featureFlags'
import { useSwipeTabs } from '../../../lib/swipe'

const ALL_TABS = [{ id:'todo', label:'To-Do', flag:'todo' }, { id:'budget', label:'Budget', flag:'budget' }]

export default function PlanningPage() {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const { flags } = useFeatureFlags()
  const TABS = ALL_TABS.filter(t => flags[t.flag] !== false)
const [tab, setTab] = useState(location.state?.tab || searchParams.get('tab') || 'todo')

useEffect(() => {
  const params = new URLSearchParams(location.search)
  const t = params.get('tab')
  if (t) setTab(t)
}, [location.search])
  useEffect(()=>{ if(location.state?.tab) setTab(location.state.tab) },[location.state])
  // If the active tab got disabled, fall back to the first enabled one
  useEffect(()=>{ if (TABS.length && !TABS.some(t=>t.id===tab)) setTab(TABS[0].id) }, [flags]) // eslint-disable-line
  const swipe = useSwipeTabs(TABS.map(t => t.id), tab, setTab)
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
      <div style={{ display:'flex', borderBottom:'1px solid #E5E0D8', marginBottom:'1.75rem' }}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            padding:'0.75rem 1.25rem', background:'none', border:'none', cursor:'pointer',
            fontFamily:'Nunito Sans, sans-serif', fontSize:'0.85rem',
            fontWeight:tab===t.id?700:500,
            color:tab===t.id?'#C4826A':'#6B6B6B',
            borderBottom:tab===t.id?'2px solid #C4826A':'2px solid transparent',
            transition:'all 0.15s', whiteSpace:'nowrap'
          }}>{t.label}</button>
        ))}
      </div>
      <div {...swipe}>
        {tab==='todo'   && <>{flags.aisle !== false && <YourVendors/>}<TodoTab onSwitchTab={setTab} /></>}
        {tab==='budget' && <BudgetPage/>}
      </div>
    </div>
  )
}
